module.exports = __webpack_public_path__ + "img/loading-icon.b0b0480f.gif";